import { render, staticRenderFns } from "./ProfileEditActionButtons.vue?vue&type=template&id=40beb7b0&scoped=true"
import script from "./ProfileEditActionButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileEditActionButtons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileEditActionButtons.vue?vue&type=style&index=0&id=40beb7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40beb7b0",
  null
  
)

export default component.exports